import { modalList, show, showTextModal } from '@/common/utils/ModalState';

export * from '@/common/utils/module/ParameterAssistant';
export * from '@/common/utils/module/FormDataSupport';
export * from '@/common/utils/module/Supplementary';
export * from '@/common/utils/module/ValidCustomMessage';
export * from '@/common/utils/module/ValidSupport';
export * from '@/common/utils/module/ScrollSupport';
export * from '@/common/utils/module/MaskingSupport';
export * from '@/common/utils/module/FormattingSupport';
export * from '@/common/utils/module/IsMobileSupport';
export * from '@/common/utils/module/SpatialSupport';
export * from '@/common/utils/module/TransformSupport';
export * from '@/common/utils/module/AuthenticateSupport';
export * from '@/common/utils/module/FlowSupport';

import { v4 as uuidv4 } from 'uuid';
import ConstCode, { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import store from '@/store';
import { isApp, isIPad, isIPhone } from '@/common/utils/module/IsMobileSupport';
import ServiceExec from '@/common/utils/ServiceExec';
import { common } from '@/common/service/apiList';
import { nativeGpsLocation } from '@/common/utils/module/NativeRequest';
import router from '@/router';

export const ObjectConverter = (regData, detail) => {
  Object.keys(regData).forEach(key => {
    if (key in detail) {
      regData[key] = detail[key];
    }
  });
};

export const fnShowIsAppModal = () => {
  show(modalList.CONFIRM, {
    contents: '앱에서만 사용가능 합니다.',
    doneText: '확인',
    cancelText: '취소',
    doneCallback: () => {
      if (isIPad() || isIPhone()) {
        location.href = 'https://itunes.apple.com/app/id6670776419';
      } else {
        location.href = 'market://details?id=com.appg.jump';
      }
    }
  });
};

// 앱에서만 사용가능 모달 + 다이나믹 링크 이동
export const fnShowIsAppModalDynamic = (urlParam = `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/link/dynamicLink/main`) => {
  show(modalList.CONFIRM, {
    contents: '앱에서만 사용가능 합니다.',
    doneText: '확인',
    cancelText: '취소',
    doneCallback: () => {
      window.open(urlParam);
    }
  });
};

export const fnShowIsLoginDynamic = nextUrl => {
  show(modalList.CONFIRM, {
    contents: '로그인 후 이용 가능합니다.',
    doneText: '로그인하기',
    cancelText: '취소',
    doneCallback: () => {
      if (isApp()) {
        router.push('/signin');
      } else {
        window.open(`${CODE_ENV_LIST.DYNAMIC_DOMAIN}/link/dynamicLink/${nextUrl}`);
      }
    }
  });
};

// 앱에서 구매하기 모달 + 다이나믹 링크
export const fnShowIsAppPurchaseModalDynamic = (urlParam = `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/link/dynamicLink/main`) => {
  console.log('도메인 :', urlParam);
  show(modalList.CONFIRM, {
    contents: '앱에서만 구매 가능합니다.',
    doneText: '확인',
    cancelText: '취소',
    doneCallback: () => {
      window.open(urlParam);
    }
  });
};

export const fnShowIsAppPurchaseModal = () => {
  show(modalList.CONFIRM, {
    contents: '앱에서만 구매 가능합니다.',
    doneText: '확인',
    cancelText: '취소',
    doneCallback: () => {
      if (isIPad() || isIPhone()) {
        location.href = 'https://itunes.apple.com/app/id6670776419';
      } else {
        location.href = 'market://details?id=com.appg.jump';
      }
    }
  });
};

export const formatDistance = distance => {
  if (!distance && distance !== 0) return '';
  if (distance >= 1000) {
    const km = Math.floor(distance / 100) / 10; // 예: 28951 → 28.9
    return km + ' km';
  }
  return Math.floor(distance) + ' m';
};

/**
 * 가족관계 리스트를 문자열로 변환
 * @param list
 * @description relation: 가족관계, name: 이름
 * @returns {*}
 */
export const joinedFamilyList = list => {
  return list
    .map(family => {
      return family.relation + ': ' + family.name;
    })
    .join(', ');
};

export const checkIsF = grade => {
  return grade === 'F';
};

export const checkIsP = grade => {
  return grade === 'P' || grade === 'P_PASS';
};

export const checkIsContract = churchStatus => {
  return churchStatus === 'CONTRACT';
};

export const checkIsB = grade => {
  return grade === 'BC' || grade === 'BC_PASS';
};

export const checkIsBeta = grade => {
  return grade === 'BETA';
};

export const checkIsPass = grade => {
  return grade.includes('PASS');
};

export const isEmpty = value => {
  return (
    value === '' ||
    value === null ||
    value === undefined ||
    (Array.isArray(value) && value.length === 0) || // ✅ 빈 배열 체크 추가
    (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length) // 객체 체크
  );
};

export const getUUID = () => uuidv4();
export const maxLengthCheck = object => {
  if (object.value.length > object.maxLength) {
    object.value = object.value.slice(0, object.maxLength);
  }
};
export const setSecondsToTime = (seconds = 0) => {
  seconds = Number(seconds);
  if (seconds < 1) {
    return '00:00';
  }
  const hours = Math.floor(seconds / (60 * 60));
  seconds -= hours * 60 * 60;
  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  return `${hours > 0 ? `${this.formatLpad(hours, 0, '2')}:` : ''}${this.formatLpad(minutes, 0, '2')}:${this.formatLpad(
    seconds,
    0,
    '2'
  )}`;
};
export const getLocalImagePath = (storedFileName = '', resolution = 'origin') => {
  if (!storedFileName) return;
  return `${CODE_ENV_LIST.LOCAL_FILE_SERVER_URL}/${resolution}/${storedFileName}`;
};

export const getImagePath = (storedFileName = '', resolution = 'origin') => {
  if (!storedFileName) return;
  return `${CODE_ENV_LIST.FILE_SERVER_URL}/${resolution}/${storedFileName}`;
};

export function getCurrentPath() {
  let currentUrl = location.href;
  const url = new URL(currentUrl); // URL 객체 생성
  const path = url.pathname; // 경로 부분 추출
  const queryString = url.search; // 쿼리 스트링 부분 추출

  return path.substring(1) + queryString;
}

export const defaultImageUrl = new URL('@/assets/static/images/defaultImage.svg', import.meta.url).href;

// 핀 마커로 설정해주는 함수
export const pinMarker = (latitude, longitude) => {
  store.commit('business/markerPin', { latitude: latitude, longitude: longitude });
};

// 해당 좌표가 현재 선택된 좌표(핀 마커)와 같은지 체크
export const selectPinCheck = (latitude, longitude) => {
  if (isEmpty(latitude) || isEmpty(longitude)) return false;
  const coordinate = store.getters['business/getMarkerPin'];
  latitude = Number(latitude.toFixed(7));
  longitude = Number(longitude.toFixed(7));
  return coordinate.latitude === latitude && coordinate.longitude === longitude;
};

export const getCurrentLocation = async () => {
  const isModal = store.getters['business/getIsLocationModal'];
  if (isApp()) {
    return new Promise(resolve => {
      nativeGpsLocation();
      resolve(true);
    });
  } else {
    return new Promise(resolve => {
      navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
        if (permissionStatus.state === 'denied') {
          if (isModal) {
            show(modalList.CONFIRM, {
              contents: '위치 허용 후 이용 가능합니다.',
              cancelText: '취소',
              doneText: '확인'
            });
          }
          store.commit('business/isLocationModal');
          resolve(null);
        } else {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              position => {
                const result = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                  isOneKM: true
                };

                console.log('위치 정보 가져오기', result);
                store.commit('business/coordinate', result);
                // 260618: GPS 실좌표 별도 보관 (유령기업 카카오는 대표주소 덮어쓰기와 무관하게 이 좌표 사용)
                store.commit('business/gpsCoordinate', result);
                store.commit('business/coordinateChange', true);
                resolve(result);
              },
              () => {
                if (isModal) {
                  show(modalList.CONFIRM, {
                    contents: '위치 허용 후 이용 가능합니다.',
                    cancelText: '취소',
                    doneText: '확인'
                  });
                }
                resolve(null);
              }
            );
          } else {
            resolve(null);
          }
        }
      });
    });
  }
};

// 260619: 사용자가 헤더(HeaderLocation)에서 명시 선택한 위치(내 위치/주소)를 화면 전환에도 유지하기 위한 캐시.
//          userNo별 키 — 다른 사용자가 같은 기기에 로그인해도 누수 없음(로그아웃 정리 불필요).
//          캐시 없으면(처음/비로그인/private모드) 호출부가 기존 동작(대표주소)으로 폴백.
const pickedLocKey = userNo => `userPickedLocation_${userNo || 'guest'}`;
export const savePickedLocation = (userNo, coordinate, selectAddress) => {
  try {
    localStorage.setItem(pickedLocKey(userNo), JSON.stringify({ coordinate, selectAddress }));
  } catch (e) { /* quota/private 모드 — 캐시 스킵 */ }
};
export const readPickedLocation = userNo => {
  try {
    return JSON.parse(localStorage.getItem(pickedLocKey(userNo)) || 'null');
  } catch (e) { return null; }
};

export const reloadingMap = async (isSearch = false, searchText = '') => {
  store.commit('business/initBusinessList');

  const flag = store.getters['business/getCategorySearchFlag'];
  if (searchText) {
    store.commit('business/searchText', searchText);
  }
  await store.dispatch('business/getBusinessList', { isKakao: !flag, isOneKM: true, isSearch });
};

export const listChange = (newData, currentList, targetNo, key, updateKeys = [], isDelete = false) => {
  const index = currentList.findIndex(item => item[key] === targetNo);

  if (index !== -1) {
    if (isDelete) {
      currentList.splice(index, 1);
      return currentList;
    }
    if (isEmpty(updateKeys)) {
      // 리스트의 정보를 통으로 덮어쓰기
      currentList[index] = newData;
    } else {
      // 수정할 키가 따로 있다면 updateKeys에 추가
      updateKeys.forEach(updateKey => {
        if (newData.hasOwnProperty(updateKey)) {
          currentList[index][updateKey] = newData[updateKey];
        }
      });
    }
  }
  return currentList;
};

// 포인트로 구매
export const pointPurchase = async () => {
  //웹 결제테스트용
  const userData = store.getters['user/getUserData'];
  const purchase = store.getters['user/getPurchase'];

  // 구매후 데이터베이스에 저장하는것 같음.
  const payload = {
    userNo: userData.userNo,
    category: purchase.category,
    productNo: purchase.productNo,
    price: purchase.price,
    itemType: purchase.productCode,
    useTargetNo: purchase.useTargetNo,
    productCode: purchase.productCode,
    productId: purchase.productId,
    name: purchase.name
  };
  const response = await ServiceExec.post(common.pointPurchase, payload);
  console.log('구매 결과', response);

  if (response.status === ServiceExec.status.OK) {
    const callBack = store.getters['user/getPurchaseCallBack'];
    const productByMove = store.getters['layout/getProductBuyMove'];
    if (callBack) {
      callBack();
      store.commit('user/setPurchaseCallBack', '');
    } else {
      showTextModal('구매가 완료되었습니다.', '확인', () => {});
    }

    // 구매 후 이전 페이지로 돌아갈것인지 여부
    if (productByMove) {
      setTimeout(() => {
        store.commit('layout/setProductBuyMove', false);
        router.go(-1);
      }, 1000);
    }
  } else {
    console.error('구매 실패', response.data);
  }
};


export const purchaseTest = async () => {
  //웹 결제테스트용
  const userData = store.getters['user/getUserData'];
  const purchase = store.getters['user/getPurchase'];

  // 구매후 데이터베이스에 저장하는것 같음.
  const payload = {
    userNo: userData.userNo,
    category: purchase.category,
    productNo: purchase.productNo,
    price: purchase.price,
    itemType: purchase.productCode,
    useTargetNo: purchase.useTargetNo,
    productCode: purchase.productCode,
    productId: purchase.productId
  };
  const response = await ServiceExec.post(common.webPurchase, payload);
  console.log('구매 결과', response);

  if (response.status === ServiceExec.status.OK) {
    const callBack = store.getters['user/getPurchaseCallBack'];
    if (callBack) {
      callBack();
      store.commit('user/setPurchaseCallBack', '');
    }
  } else {
    console.error('구매 실패', response.data);
  }
};

export const getAddressCity = address => {
  if (isEmpty(address)) return '';
  const parts = address.split(' ');

  if (parts[0].endsWith('광역시') || parts[0].endsWith('특별시')) {
    parts[0] = parts[0].replace(/(광역|특별)?시$/, '');
  }

  if (parts.length >= 2) {
    const second = parts[1] || '';
    const third = parts[2] || '';
    if (third.endsWith('동') || second.endsWith('시')) {
      return parts.slice(0, 3).join(' ');
    } else {
      return parts.slice(0, 2).join(' ');
    }
  } else {
    return address;
  }
};
